import axios from 'axios';
import AppConsts from '../Constants/AppConsts';

const apiInstance = axios.create({
    baseURL: AppConsts.remoteServiceBaseUrl,
    timeout: AppConsts.apiClientTimeout,
  });

apiInstance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if(error.message !== 'canceled') {
    const user = JSON.parse(localStorage.getItem("user"));
    axios.post(`${AppConsts.remoteServiceBaseUrl}/api/logs`,
    {
      url: window.location.href,
      // Fall back to error.config: a request that got NO response (CORS block, DNS failure, timeout)
      // has no error.response, and used to be logged with every field empty.
      apiUrl: error?.response?.config?.url ?? error?.config?.url,
      payload: error?.response?.config?.data ?? `[no response] ${error?.code || ''} ${error?.message || ''}`.trim(),
      method: error?.response?.config?.method ?? error?.config?.method,
      status: error?.response?.status,
      userId: user?.userId
    });
  }
    return Promise.reject(error);
});


export default function (url, options) {
    return apiInstance({ url, ...options });
}
